import { MapPin } from "lucide-react";
import { SAMPLE_TRIP } from "./fixtures";

/** Mock of the Pods gallery: three location-clustered cards. */
export function PodsPreview() {
  return (
    <div className="w-full h-full p-3 space-y-2 overflow-hidden">
      {SAMPLE_TRIP.pods.map((pod) => (
        <div key={pod.id} className="flex gap-2 rounded-xl border border-[var(--roava-border)] bg-[var(--roava-bg)] p-2">
          <div className="flex flex-col gap-1">
            {pod.photos.slice(0, 2).map((p) => (
              <div key={p.id} className="size-12 rounded-md overflow-hidden bg-[var(--roava-border)]">
                <img src={p.url} alt="" className="w-full h-full object-cover" loading="lazy" draggable={false} />
              </div>
            ))}
          </div>
          <div className="min-w-0 flex-1 flex flex-col justify-center">
            <p className="text-[12px] font-semibold text-[var(--roava-text)] truncate inline-flex items-center gap-1">
              <MapPin className="size-3 text-[var(--roava-blue)]" />
              {pod.placeName}
            </p>
            <p className="text-[10px] text-[var(--roava-text-muted)]">{pod.timeLabel}</p>
            <p className="text-[10px] text-[var(--roava-text-muted)] mt-0.5">{pod.photos.length} photos</p>
          </div>
        </div>
      ))}
    </div>
  );
}
